
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getFaultCode, saveBatchSetting } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class AlarmSettingBatchDetail extends Vue {
  private name = "alarmSetting-batch-detail";
  private getSelectionFun: objAny = {};

  private modalShow = false;
  private tableLoading = false;
  private loading = true;
  private roleList = [];
  private FormData: objAny = {};
  private modalTitle = i18n.t("alarmsetting.setLevel");
  private ruleInline: objAny = {};
  private formItem: objAny = {
    alarmLevelName: ""
  };
  private formInline: objAny = {
    pageNo: 1,
    pageSize: 10
  };
  private tableListFirst: object[] = [];
  private tableColumnsFirst: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    // {
    //   title: "序号",
    //   key: "index",
    //   resizable: true,
    //   minWidth: 60,
    //   slot: "index"
    // },
    {
      title: i18n.t("alarmsetting.faultCode"),
      key: "faultCode",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("alarmsetting.faultName"),
      key: "faultName",
      resizable: true,
      minWidth: 130
    }
  ];
  private selectList: object[] = [];

  private faultCodeList: object[] = [];
  private alarmLevel = "";

  public open(item: objAny) {
    this.faultCodeList = [];
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
        this.getSelectionFun = this.$refs["getSelection"];
      });
    } else {
      this.handleReset();
    }

    this.modalShow = true;
    this.formItem = item;
    this.alarmLevel = item.alarmLevelId;
    this.getFaultCode(item.alarmLevelId);
  }

  public handleSubmit(): void {
    this.loading = true;

    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }

  public selectItem(list: object[]) {
    this.faultCodeList = [];
    this.selectList = list;
    list.map((item: objAny) => {
      this.faultCodeList.push(item.faultCode);
    });
  }

  async submitData(): Promise<void> {
    // let ret: objAny;
    this.loading = false;
    const param = {
      alarmLevel: this.alarmLevel,
      faultCodeList: this.faultCodeList
    };
    const ret = await saveBatchSetting(param);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
  }
  async getFaultCode(val: string): Promise<void> {
    this.tableLoading = true;
    const ret = await getFaultCode({ alarmLevel: val });
    if (ret.status === this.$config.apiStatus) {
      for (let i = 0; i < ret.data.length; i++) {
        const element = ret.data[i];
        element.index = i;
        if (element.checked) {
          element._checked = true;
        }
      }
      this.tableListFirst = ret.data;
      this.tableLoading = false;
    }
  }

  mounted() {
    this.$emit("getChild", this);
  }
}
